// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SidebarHeader__header___OzYiO {
    width: 100%;
    height: 4.8rem;
    padding: 0 var(--space-m);
}

.SidebarHeader__text___e9ICi {
    max-width: 22rem;
}
`, "",{"version":3,"sources":["webpack://./../GM.Frontend.Library/src/components/Template/NavigationSidebar/SidebarHeader/SidebarHeader.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".header {\n    width: 100%;\n    height: 4.8rem;\n    padding: 0 var(--space-m);\n}\n\n.text {\n    max-width: 22rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `SidebarHeader__header___OzYiO`,
	"text": `SidebarHeader__text___e9ICi`
};
export default ___CSS_LOADER_EXPORT___;
